// 基准大小（设计稿宽度，默认 1920）
const baseSize = 192;
// 设置 rem 函数
function setRem() {
  // 当前页面宽度相对于 1920 宽的缩放比例，可根据自己需要修改
  const scale = document.documentElement.clientWidth / 1920;
  // 设置页面根节点字体大小
  document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px';
}
// 初始化
setRem();
// 改变窗口大小时重新设置 rem
window.onresize = function () {
  setRem();
};

// 获取当前屏幕缩放比例（与 setRem 保持一致，最大 2 倍），供 ECharts 等 JS 内 fontSize 自适应
export function getScreenScale() {
  return Math.min(document.documentElement.clientWidth / 1920, 2);
}

export default setRem;